/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Button } from "@mui/material";
import * as Sentry from "@sentry/react";
import Toast from "../../../components/common/Toast";
import ViewIntroduction from "../../../services/api/viewIntroduction";
import InputField from "../../../components/common/new/InputField/InputField";
import Styles from "../styles";
import { INTRODUCTION_TYPE, MEMBER_TYPE } from "../../../contants";
import Member from "../../../services/api/member";
import Friends from "../../../services/api/friend";

function AddRemarkForm({ selectedItem, pageType, refreshRemarks }) {
  const [remarkText, setRemarkText] = useState("");
  const [showToast, setShowToast] = useState(null);
  const { id } = useParams();

  const onRemarkSubmit = async () => {
    try {
      const body = {
        data: {
          message: remarkText,
        },
      };
      let response = null;
      if (pageType === INTRODUCTION_TYPE) {
        response = await ViewIntroduction.addRemark({ id, data: body });
      } else if (pageType === MEMBER_TYPE) {
        response = await Member.addRemarkForMemberTransfer({
          memberId: selectedItem.memberId,
          transfereRequestId: selectedItem.transferId,
          data: body,
        });
      } else {
        response = await Friends.addRemarkForFriendTransfer({
          friendId: selectedItem.friendId,
          transfereRequestId: selectedItem.transferId,
          data: body,
        });
      }

      // const response = await ViewIntroduction.addRemark({ id, data: body });
      if (response.code === 201) {
        setRemarkText("");
        refreshRemarks();
        setShowToast({
          message: "Remark submitted successfully",
          severity: "success",
        });
      }
    } catch (error) {
      setShowToast({ message: error.message, severity: "error" });
      Sentry.captureException(error);
    }
  };
  return (
    <Box style={Styles.ForwardIntroContainer}>
      <Box>
        <Grid md={8} xs={8}>
          <Box sx={{ maxWidth: "80%" }}>
            <InputField
              type="text"
              fullWidth
              defaultValue=""
              key="remark"
              name="remark"
              label="Your Remark"
              // required
              value={remarkText}
              onChange={(e) => setRemarkText(e.target.value)}
            />
          </Box>
          <Box style={Styles.buttonBox}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#043D90",
                width: "150px",
                height: "50px",
                borderRadius: "2rem",
                px: "2.2rem",
                py: ".8rem",
                fontSize: "18px",
                fontWeight: "500",
                textTransform: "capitalize",
                ml: 10,
                mt: -8,
                mb: 5,
              }}
              onClick={onRemarkSubmit}
            >
              Submit
            </Button>
          </Box>
        </Grid>
        {/* <Grid container spacing={2}> */}

        {/* </Grid> */}
      </Box>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default AddRemarkForm;
